import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {showToast} from '@/components/Toaster/Toaster';
import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import useIsSettingHolderRelated from '@/hooks/useIsSettingHolderRelated';
import appContent from '@/services/content/appContent';
import connectivityService from '@/services/device/connectivityService';
import deviceTypesService from '@/services/device/deviceTypesService';
import {
    selectDeviceType,
    selectIsHolderConnectedToIot,
    selectIsSelectedDeviceConnectedToIot,
} from '@/state/selectors/device';

const useDeviceSettingHolderGuard = (settingType) => {
    const isDeviceConnected = useSelector(selectIsSelectedDeviceConnectedToIot);
    const isHolderConnected = useSelector(selectIsHolderConnectedToIot);
    const isSettingHolderRelated = useIsSettingHolderRelated(settingType);
    const deviceType = useSelector(selectDeviceType);
    const isMono = deviceTypesService.isMono(deviceType);
    const isShowNoHolderBanner =
        (settingType === AEM_DEVICE_SETTINGS_TYPES.ILLUMINATION_MODE && !isMono) || isSettingHolderRelated;

    const shouldShowNoHolderBanner = isDeviceConnected && !isHolderConnected && isShowNoHolderBanner;
    const shouldDisableSaveButton = isDeviceConnected && !isHolderConnected && isSettingHolderRelated;
    const shouldDisableInputs = !isDeviceConnected || shouldDisableSaveButton;
    const isUsb = connectivityService.isUsb();
    const noHolderNotification = isUsb ? appContent.getNoHolderUsbNotification() : appContent.getNoHolderNotification();

    // TODO: Add a toast content
    const {title, description, button} = isDeviceConnected
        ? noHolderNotification
        : {
              title: 'Device is not connected',
              description: 'Connect your device to change lock settings',
          };

    const onDisabledSaveClick = useCallback(() => {
        showToast(title, {
            description,
            action: button
                ? {
                      label: button.text,
                      onClick: () => {
                          // Any additional logic can go here. Toast will close automatically.
                      },
                  }
                : undefined,
        });
    }, []);

    return {
        shouldShowNoHolderBanner,
        shouldDisableInputs,
        shouldDisableSaveButton,
        onDisabledSaveClick,
    };
};

export default useDeviceSettingHolderGuard;
